module.exports = [{
      plugin: require('/msata/projets/stcyp.net/node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"4","matomoUrl":"https://piwik.dediboite.fr","siteUrl":"https://stcyp.net"},
    },{
      plugin: require('/msata/projets/stcyp.net/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
